import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/2003-Human-Genome.jpg');

const GenomeContent = () => {
    return (
        <>
            <TimelineVideo videoId="jPibB2YL9Tw" imagePreview={VideoPreview} />
            <h4>
                The human genome is sequenced
            </h4>
        </>
    );
}

export default GenomeContent;